import React from 'react';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';

import * as css from './index.module.css';

export default function Community() {
    return (
        <>
            <SectionHeader name="community" />

            <div className={css.section}>
                <h3>{i18n('part4.c.subheader')}</h3>

                <div className={css.cols}>
                    <p className={css.col}>{i18n('part4.c.para.0')}</p>
                    <p className={css.col}>{i18n('part4.c.para.1')}</p>
                </div>
            </div>
        </>
    );
}

